<template>
    <ModalDialog :show="openModal" headline="Speicher-Link">
        <HashCopy :hash-link="hashLink"/>
    </ModalDialog>
    <div class="relative">
        <AxiosOverlayer :loading="axiosCall"/>
        <form id="calculator" @submit.prevent="onSubmit(false)" novalidate>
            <section class="container mx-auto px-2 py-4 relative z-20">
                <h1 class="flex justify-between items-center">Eingabe
                  <div class="flex">
                    <base-button type="submit" :loading="axiosCall" class="button-min-width" button-class="invert" :disabled="disableForm">
                        {{ edit ? 'Speichern' : 'Speichern' }}
                    </base-button>
                    <base-button :router-link="true" link="/projects" class="ml-2" button-class="invert">Zur Projektübersicht</base-button>
                  </div>
                </h1>
                <div class="box">
                    <div class="flex flex-wrap -mx-4">
                        <div v-if="disableForm" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 mx-4" role="alert">
                            <strong class="font-bold">
                                Es hat seit dem letzten Bearbeiten dieses Projektes eine Anpassung bei den Berechnungen gegeben. Sie können lediglich ihre alten Ergebnisse aufrufen, aber diese nicht mehr nachträglich bearbeiten. Für eine Berechnungen mit aktuellen Parametern, können Sie gern ein <router-link class="underline cursor-pointer text-black" to="/form">neues Projekt</router-link> anlegen. <br><br>Eine Übersicht zu den einzelnen Anpassungen finden Sie <router-link class="underline cursor-pointer text-black" to="/changelogs">hier</router-link>.
                            </strong>
                        </div>
                        <div class="w-full md:w-1/2 px-4 flex flex-col items-start justify-start">
                            <h2 class="flex items-center">Allgemeine Objektdaten
                                <div class="inline-block ml-1 flex items-center">
                                    <Tooltipp>
                                        <template v-slot:message>{{
                                                $t('calculator.tt_allgemeine_objektdaten')
                                            }}
                                        </template>
                                    </Tooltipp>
                                </div>
                            </h2>
                            <base-input v-model.trim="generalData.name"
                                        :id-prefix="'object'"
                                        class="w-full"
                                        name="object"
                                        placeholder="Objekt"
                                        ref="main-object"
                                        :type="'text'" label="default.object" :readonly="disableForm"/>
                            <base-input v-model.trim="generalData.street"
                                        :id-prefix="'main'"
                                        class="w-full"
                                        name="street"
                                        ref="main-street"
                                        :type="'text'" label="default.street" :readonly="disableForm"/>
                            <base-input :model-value="'v' + appVersion"
                                        class="w-full"
                                        :border-color="disableForm ? 'border-red-700': ''"
                                        :label-color="disableForm ? 'text-red-700': ''"
                                        :label-color-hover="disableForm ? 'text-red-700': ''"
                                        :border-color-hover="disableForm ? 'border-red-700': ''"
                                        :type="'text'" :readonly="true" label="default.version"/>
                        </div>
                        <div class="w-full md:w-1/2 px-4 flex flex-col items-start justify-end">
                            <h2 class="flex-grow">Bearbeiter</h2>
                            <base-input v-model.trim="generalData.projectNumber"
                                        :id-prefix="'project_number'"
                                        class="w-full"
                                        name="project_number"
                                        ref="main-project_number"
                                        :type="'text'" label="default.project_number" :readonly="disableForm"/>
                            <base-input v-model.trim="generalData.company"
                                        :id-prefix="'company'"
                                        class="w-full"
                                        name="company"
                                        ref="main-company"
                                        :type="'text'" label="default.company" :readonly="disableForm"/>
                            <base-input v-model.trim="generalData.date"
                                        :id-prefix="'date'"
                                        class="w-full"
                                        name="date"
                                        :is-date="true"
                                        ref="main-date"
                                        :type="'text'" label="default.date" :readonly="disableForm"/>

                        </div>
                        <div v-if="!disableForm" class="w-full md:w-full px-4 flex flex-col items-start justify-start">
                            <div class="w-full flex text-sm text-gray-400 cursor-pointer items-center transition ease-in-out duration-500" @click="clearGeneralData" :class="clearButtonClass">
                                <span>zurück setzen</span>
                                <Icon name="return" class="ml-1"/>
                            </div>
                            <div class="text-sm mt-2">
                                Zur Vermeidung der Speicherung personenbezogener Daten sollten hier lediglich allgemeine
                                Informationen zur Identifikation des Projektes
                                eingegeben werden, beispielsweise wie vorgesehen ohne Namen und vollständige Adresse.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="bg-body-color relative z-10">
                <div class="container mx-auto py-12 pt-40 -mt-36 px-2">
                    <section class="mb-10">
                        <h2>Auswahl Gebäude und Anforderungsniveau</h2>
                        <div class="-mx-4 flex">
                            <div class="px-4 w-full md:w-1/2">
                                <div class="border border-gray-200 p-2 mb-4 ">
                                    <div id="house-state-tabs" class="flex justify-between">
                                        <template v-for="(houseState, houseStatesIndex) in houseStates">
                                            <div class="text-gray-100 w-full p-2 text-center font-bold flex items-center flex-col justify-center" :data-house-state="houseState" :class="[ activeHouseState == houseState ? 'bg-neutral-default text-white' : 'bg-white text-neutral-default', disableForm || !(calculationData.active_house_states ?? []).includes(houseState) ? 'opacity-50' : 'cursor-pointer']" @click="disableForm || !(calculationData.active_house_states ?? []).includes(houseState) ? false : setHouseState(houseState)">
                                              {{ $t('calculator.' + houseState) }} <span v-if="houseState == 'neubau'" class="block text-xs">(in Überarbeitung)</span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="house-state-tabs-content" class="flex flex-wrap md:flex-nowrap items-stretch justify-between -mx-4">
                            <div class="px-4 w-full md:w-1/2 mb-4 md:mb-0">
                                <template v-for="(houseState, houseStatesIndex) in houseStates">
                                    <div v-if="activeHouseState == houseState" class="frame py-0 pb-2 h-full">
                                        <div class="pt-4">
                                            <h3>Gebäudetyp</h3>
                                            <div class="flex justify-between -mx-1 mb-4">
                                                <div v-for="(houseVariant, houseVariantsIndex) in houseVariants" class="px-1 w-full">
                                                    <div class="frame-box">
                                                        <base-radiobutton
                                                            :id="houseVariant"
                                                            v-model="activeHouseVariant"
                                                            name="house_variant"
                                                            :radio-value="houseVariant"
                                                            :disabled="disableForm"
                                                            :class="{'pointer-events-none': disableForm}"
                                                            @update="(value) => { setHouseVariant(value)}"
                                                        >
                                                            <div class="flex items-center">
                                                                <Icon :name="houseVariant" class="text-primary-default mr-2" :height="8" :width="8"/>
                                                                <div class="font-bold">
                                                                    {{ $t('calculator.' + houseVariant) }}
                                                                </div>
                                                            </div>
                                                        </base-radiobutton>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex items-center mt-2 mb-2" v-if="activeHouseState == 'neubau'">
                                                <h3 class="mb-0">{{
                                                        $t('calculator.variation_' + activeHouseState)
                                                    }}</h3>
                                                <div class="inline-block ml-1 flex items-center">
                                                    <Tooltipp width="400">
                                                        <template v-slot:message>
                                                            <span v-html="$t('calculator.tt_waermeschutzniveau_'+activeHouseState)"></span>
                                                        </template>
                                                    </Tooltipp>
                                                </div>
                                            </div>
                                            <div v-for="(houseAction, houseActionIndex) in houseActions[houseState]" class="px-1 w-full frame-box">
                                                <base-radiobutton
                                                    :id="houseAction"
                                                    v-model="activeHouseAction"
                                                    name="house_variant"
                                                    :radio-value="houseAction"
                                                    :disabled="disableForm"
                                                    :class="{'pointer-events-none': disableForm}"
                                                    @update="(value) => { setHouseAction(houseState, value)}"
                                                >
                                                    {{ $t('calculator.change_' + houseAction) }}
                                                </base-radiobutton>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div v-if="calculationData.energieverbrauch && activeHouseState == 'altbau'" class="px-4 w-1/2 w-full md:w-1/2">
                                <div class="frame py-0 pb-2 h-full">
                                    <div class="pt-4">
                                        <h3 class="flex items-center">Endenergiebedarf für Heizung und
                                            Trinkwassererwärmung
                                            <div class="inline-block ml-1 flex items-center">
                                                <Tooltipp position-x="right" width="400">
                                                    <template v-slot:message>{{
                                                            $t('calculator.tt_endenergiebedarf')
                                                        }}
                                                    </template>
                                                </Tooltipp>
                                            </div>
                                        </h3>
                                        <div class="flex justify-between pt-8 pb-10">
                                            <div class="flex-grow-0 flex items-center">
                                                <Icon :name="getIconName('rate_' + activeHouseAction)" class="text-primary-default mr-2" :height="8" :width="8"/>
                                                <div>{{ $t('calculator.rate_' + activeHouseAction) }}</div>
                                            </div>
                                            <div class="flex-grow text-right lining-nums tabular-nums">
                                                {{
                                                    formatValue(energieverbrauchValue, {
                                                        symbol: '',
                                                        format: '%v',
                                                        precision: 0,
                                                        decimal: ',',
                                                        thousand: '.'
                                                    })
                                                }} {{ energieverbrauchUnit }}
                                            </div>
                                        </div>
                                        <div class="frame-box flex items-center justify-between">
                                            <span class="mr-2 flex-grow-0 block whitespace-nowrap text-xs lining-nums tabular-nums">-30 %</span>
                                            <div class="w-full flex-grow">
                                                <Slider v-model="energieverbrauchPercent" :min="-30" :max="30" :step="5" class="percent-slider" :disabled="disableForm" :class="{'pointer-events-none': disableForm}"/>
                                            </div>
                                            <span class="ml-2 flex-grow-0 block whitespace-nowrap text-xs lining-nums tabular-nums">+30 %</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="flex items-center mb-2">Hinweise zur Anpassung/Individualisierung des
                        Berechnungsbeispiels
                        <div class="inline-block ml-1 flex items-center">
                            <Tooltipp>
                                <template v-slot:message>{{
                                        $t('calculator.tt_hinweise_individualisierung')
                                    }}
                                </template>
                            </Tooltipp>
                        </div>
                    </div>
                    <section v-if="calculationData.energiepreise" class="mb-10">
                        <h2>Energiepreise und Hausanschlusskosten</h2>

                        <div>
                            <table class="whitespace-no-wrapw-full whitespace-no-wrap w-full relative">
                                <thead>
                                <tr>
                                    <th class="pl-0 px-2 py-4 bg-body-color text-center hyphens-auto align-top border-r" rowspan="3">
                                        <span class="flex items-center">Energieträger <div class="inline-block ml-1 flex items-center">
                                            <Tooltipp>
                                                <template v-slot:message>{{
                                                        $t('calculator.tt_energietraeger')
                                                    }}</template>
                                            </Tooltipp>
                                        </div></span>
                                    </th>
                                    <th class="px-2 py-4 bg-body-color text-center hyphens-auto align-top border-r" rowspan="3">
                                        Abnahmemenge
                                    </th>
                                    <th class="px-2 py-4 bg-body-color text-center hyphens-auto align-top border-r" rowspan="2">
                                        Hausanschlusskosten
                                    </th>
                                    <th colspan="2" class="px-2 py-4 bg-body-color hyphens-auto align-top">
                                        Energiepreise
                                    </th>
                                    <th class="pr-0 px-2 py-4 bg-body-color">
                                    </th>
                                </tr>
                                <tr>

                                    <th class="px-2 py-4 bg-body-color hyphens-auto align-top text-sm">
                                        Grundpreis
                                    </th>
                                    <th class="px-2 py-4 bg-body-color hyphens-auto align-top text-sm">
                                        Arbeitspreis
                                    </th>
                                </tr>
                                <tr>
                                    <th class="px-2 pb-4 bg-body-color hyphens-auto align-top text-sm border-r">
                                        €
                                    </th>
                                    <th class="px-2 pb-4 bg-body-color hyphens-auto align-top text-sm">
                                        €/a
                                    </th>
                                    <th class="px-2 pb-4 bg-body-color hyphens-auto align-top text-sm">
                                        €/kWh
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="energiepreiseData[activeHouseSelection]">
                                <template v-for="(einergiepreis, einergiepreisIndex) in calculationData.energiepreise">
                                    <tr :data-slug="einergiepreis.slug" class="table-row">
                                        <td class="pl-0 px-2 py-4 align-top text-left" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            <div class="flex items-center">
                                                <Icon :name="getIconName(einergiepreis.slug)" class="text-primary-default mr-2" :height="8" :width="8"/>
                                                <div>{{ einergiepreis.energietraeger }}</div>
                                            </div>
                                        </td>
                                        <td class="px-2 py-4 align-top text-left lining-nums tabular-nums" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            {{ einergiepreis.abnahmemenge }}
                                        </td>
                                        <td v-if="einergiepreis.hausanschlusskosten" class="px-2 py-4 align-top text-center lining-nums tabular-nums" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            <base-input v-if="energiepreiseData[activeHouseSelection][einergiepreisIndex]" v-model.trim="energiepreiseData[activeHouseSelection][einergiepreisIndex].hausanschlusskosten"
                                                        class="w-full"
                                                        style="margin-bottom: 0; min-width: 150px;"
                                                        :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                                        :name="'hausanschlusskosten_' + activeHouseSelection + '_' + einergiepreis.slug"
                                                        :org-value="einergiepreis.hausanschlusskosten"
                                                        :readonly="disableForm"
                                                        :only-number="true"
                                                        :type="'text'"/>
                                        </td>
                                        <td v-else class="px-2 py-4 align-top text-center" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            -
                                        </td>
                                        <td v-if="einergiepreis.grundpreis" class="px-2 py-4 align-top" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            <base-input v-if="energiepreiseData[activeHouseSelection][einergiepreisIndex]" v-model.trim="energiepreiseData[activeHouseSelection][einergiepreisIndex].grundpreis"
                                                        class="w-full"
                                                        style="margin-bottom: 0; min-width: 150px;"
                                                        :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                                        :name="'grundpreis_' + activeHouseSelection + '_' + einergiepreis.slug"
                                                        :org-value="einergiepreis.grundpreis"
                                                        :only-number="true"
                                                        :number-format="{precision : 0,thousand : '.', decimal : ','}"
                                                        :unformat="false"
                                                        :readonly="disableForm"
                                                        :type="'text'"/>
                                        </td>
                                        <td v-else class="px-2 py-4 align-top text-center" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            -
                                        </td>
                                        <td v-if="einergiepreis.arbeitspreis" class="px-2 py-4 align-top" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            <base-input v-if="energiepreiseData[activeHouseSelection][einergiepreisIndex]" v-model.trim="energiepreiseData[activeHouseSelection][einergiepreisIndex].arbeitspreis"
                                                        class="w-full"
                                                        style="margin-bottom: 0; min-width: 150px;"
                                                        :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                                        :name="'arbeitspreis_' + activeHouseSelection + '_' + einergiepreis.slug"
                                                        :org-value="einergiepreis.arbeitspreis"
                                                        :only-number="true"
                                                        :number-format="{precision : 4,thousand : '.', decimal : ','}"
                                                        :unformat="false"
                                                        :readonly="disableForm"
                                                        :type="'text'"/>
                                        </td>
                                        <td v-else class="px-2 py-4 align-top text-center" :class="{'border-t': (einergiepreisIndex != 0)}">
                                            -
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                            <div class="mt-4" v-if="calculationData.zinssatz">
                                <div class="flex items-center w-full md:w-3/5 p-4 bg-gray-200">
                                    <div class="p-2 pl-0 flex-grow w-full">
                                        <span class="flex items-center">Zinssatz
                                        <div class="inline-block ml-1 flex items-center">
                                            <Tooltipp>
                                                <template v-slot:message>{{ $t('calculator.tt_zinssatz') }}</template>
                                            </Tooltipp>
                                        </div>
                                        </span>
                                    </div>
                                    <base-input v-if="calculationData.zinssatz" v-model.trim="zinssatzData"
                                                class="flex-grow-0"
                                                style="margin-bottom: 0; min-width: 150px;"
                                                :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                                :name="'zinssatz'"
                                                :org-value="calculationData.zinssatz"
                                                :only-number="true"
                                                :number-format="{precision : 2,thousand : '.', decimal : ','}"
                                                :readonly="disableForm"
                                                :type="'text'"/>
                                    <div class="p-2 w-0">%</div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="horizontal-divider" v-if="calculationData.einspeiseverguetung_pv_strom"></div>
                    <section class="mb-10" v-if="calculationData.einspeiseverguetung_pv_strom">
                        <h2 class="flex items-center">Vergütung für Strom aus Photovoltaikanlagen</h2>
                        <div class="flex items-center w-full md:w-3/5">
                            <span class="p-2 pl-0 flex-grow w-full">
                                Einspeisevergütung PV-Strom
                            </span>
                            <base-input v-if="einspeiseverguetungPvStromData[activeHouseVariant]" v-model.trim="einspeiseverguetungPvStromData[activeHouseVariant]"
                                        class="flex-grow-0"
                                        style="margin-bottom: 0; min-width: 150px;"
                                        :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                        :name="'einspeiseverguetung_pv_strom' + activeHouseVariant"
                                        :org-value="calculationData.einspeiseverguetung_pv_strom"
                                        :only-number="true"
                                        :number-format="{precision : 4,thousand : '.', decimal : ','}"
                                        :readonly="disableForm"
                                        :type="'text'"/>
                            <div class="p-2 w-0">€/kWh</div>
                        </div>
                    </section>
                    <div class="horizontal-divider"></div>
                    <section v-if="calculationData.investitionskosten_und_foerderungen">
                        <h2 class="flex items-center">Investitionskosten und Förderungen</h2>
                        <div>
                            <table id="investitionskosten" class="whitespace-no-wrapw-full whitespace-no-wrap w-full relative">
                                <thead>
                                <tr class="table-row">
                                    <th class="first-col pl-0 px-2 py-4 bg-body-color text-left" rowspan="2">

                                    </th>
                                    <th class="input-col px-2 py-4 bg-body-color text-left hyphens-auto align-top border-r">
                                        <div class="flex items-start">
                                            <Icon :name="'heizung'" class="text-primary-default mr-2" :height="8" :width="8"/>
                                            <div>Wärmeerzeugung
                                                <div class="inline-block ml-1 transform translate-y-1">
                                                    <Tooltipp>
                                                        <template v-slot:message>{{
                                                                $t('calculator.tt_waermeerzeugung_' + activeHouseState)
                                                            }}
                                                        </template>
                                                    </Tooltipp>
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="input-col px-2 py-4 bg-body-color text-left hyphens-auto align-top border-r">
                                        <div class="flex items-start">
                                            <Icon :name="'tropfen'" class="text-primary-default mr-2" :height="8" :width="8"/>
                                            <div>Warmwasserbereitung
                                                <div class="inline-block ml-1 transform translate-y-1">
                                                    <Tooltipp>
                                                        <template v-slot:message>
                                                            {{ $t('calculator.tt_warmwasserbereitung') }}
                                                        </template>
                                                    </Tooltipp>
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="input-col px-2 py-4 bg-body-color text-left align-top border-r">
                                        <div class="flex items-start">
                                            <Icon :name="'foerderung'" class="text-primary-default mr-2" :height="8" :width="8"/>
                                            <div>Förderung
                                                <div class="inline-block ml-1 transform translate-y-1">
                                                    <Tooltipp>
                                                        <template v-slot:message>
                                                          <span v-html="$t('calculator.tt_foerderung_' + activeHouseState)"></span>
                                                        </template>
                                                    </Tooltipp>
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="last-col px-2 py-4 bg-body-color whitespace-nowrap align-top" rowspan="2">
                                        Zu berechnende Variante
                                        <div class="p-2 text-center w-full bg-white">
                                            <base-checkbox
                                                :name="'toggle_variants'"
                                                @input="toggleVariants"
                                                :checked="allVariantsChecked"
                                                :disabled="disableForm"
                                                :class="{'pointer-events-none': disableForm}"
                                            >
                                                {{
                                                    allVariantsChecked ? 'Alle Varianten abwählen' : 'Alle Varianten berechnen'
                                                }}
                                            </base-checkbox>
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="input-col px-2 pb-4 bg-body-color text-left align-top border-r">
                                        <span class="block text-center mt-1">€</span>
                                    </th>
                                    <th class="input-col px-2 pb-4 bg-body-color text-left align-top border-r">
                                        <span class="block text-center mt-1">€</span>
                                    </th>
                                    <th class="input-col px-2 pb-4 bg-body-color text-left align-top border-r">
                                        <span class="block text-center mt-1">€ / %</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="investitionskostenUndFoerderungenData[activeHouseSelection]">

                                <template v-for="(investUndFoard, investUndFoardIndex) in calculationData.investitionskosten_und_foerderungen">
                                    <tr :data-slug="investUndFoard.slug" class="table-row">
                                        <td class="first-col pl-0 px-2 py-4 align-top text-left " :class="{'border-t': (investUndFoardIndex != 0)}">
                                          <span class="inline-block mt-1 relative">{{ investUndFoard.name }}<span v-if="investUndFoard.erneuerbar_65" class="text-primary-default inline-block pl-1">*)</span></span>
                                        </td>
                                        <td v-if="isNotEditable(investUndFoard.slug)" class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            -
                                        </td>
                                        <td v-else-if="investUndFoard.waermeerzeugung" class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            <base-input v-if="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]" v-model.trim="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].waermeerzeugung"
                                                        class="w-full"
                                                        style="margin-bottom: 0; min-width: 150px;"
                                                        @input="changeInvestitionskosten(investUndFoard,investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex])"
                                                        :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                                        :name="'waermeerzeugung_' + activeHouseSelection + '_' + investUndFoard.slug"
                                                        :org-value="investUndFoard.waermeerzeugung"
                                                        :only-number="true"
                                                        :readonly="disableForm"
                                                        :type="'text'"/>
                                        </td>
                                        <td v-else class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            -
                                        </td>
                                        <td v-if="isNotEditable(investUndFoard.slug)" class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            -
                                        </td>
                                        <td v-else-if="investUndFoard.warmwasserbereitung" class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            <base-input v-if="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]" v-model.trim="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].warmwasserbereitung"
                                                        class="w-full"
                                                        style="margin-bottom: 0; min-width: 150px;"
                                                        @input="changeInvestitionskosten(investUndFoard,investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex])"
                                                        :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                                        :name="'warmwasserbereitung_' + activeHouseSelection + '_' + investUndFoard.slug"
                                                        :org-value="investUndFoard.warmwasserbereitung"
                                                        :only-number="true"
                                                        :readonly="disableForm"
                                                        :type="'text'"/>
                                        </td>
                                        <td v-else class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            -
                                        </td>
                                        <td v-if="isNotEditable(investUndFoard.slug)" class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            -
                                        </td>
                                        <td v-else class="input-col px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            <template v-if="typeof investUndFoard.foerderung_prozent_waermeerzeugung_warmwasserbereitung !=='undefined' && typeof investUndFoard.foerderung_prozent_solarthermie !=='undefined'">
                                              <div class="flex flex-row">
                                                <div class="flex flex-grow border border-gray-200 p-4 bg-body-color">
                                                  <div v-if="isFoerderungTabActive(investUndFoardIndex,investUndFoard.slug)" class="flex-grow">
                                                    <div class="text-xs mb-2">Förderung gesamt in €</div>
                                                    <div class="px-3 py-1 border border-gray-200 text-center lining-nums tabular-nums w-full">{{ getFoerderungByPercent(investUndFoardIndex, true) }}</div>
                                                    <div class="flex flex-row -mx-2 items-stretch mt-2">
                                                      <div class="w-full px-2 flex justify-end flex-col">
                                                        <div class="text-xs mb-2">Wärmeerzeugung + Warmwasserbereitung in %</div>
                                                        <base-input v-if="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]" v-model.trim="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].foerderung_prozent_waermeerzeugung_warmwasserbereitung_custom"
                                                                    class="w-full"
                                                                    style="margin-bottom: 0; min-width: 150px;"
                                                                    :border-color="'border-white'"
                                                                    :input-class="'text-center lining-nums tabular-nums'"
                                                                    :name="'foerderung_prozent_waermeerzeugung_warmwasserbereitung_' + activeHouseSelection + '_' + investUndFoard.slug"
                                                                    :org-value="investUndFoard.foerderung_prozent_waermeerzeugung_warmwasserbereitung"
                                                                    :only-number="true"
                                                                    :number-format="{precision : 2,thousand : '', decimal : ','}"
                                                                    :readonly="!investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]?.foerderung_calculation_percent"
                                                                    :type="'text'"/>
                                                      </div>
                                                      <div class="w-full px-2 flex justify-end flex-col" v-if="unformatValue(investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]?.foerderung_prozent_solarthermie) > 0">
                                                        <div class="text-xs mb-2">Solarthermie in %</div>
                                                        <base-input v-if="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]" v-model.trim="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].foerderung_prozent_solarthermie_custom"
                                                                    class="w-full"
                                                                    style="margin-bottom: 0; min-width: 150px;"
                                                                    :border-color="'border-white'"
                                                                    :input-class="'text-center lining-nums tabular-nums'"
                                                                    :name="'foerderung_prozent_solarthermie_' + activeHouseSelection + '_' + investUndFoard.slug"
                                                                    :org-value="investUndFoard.foerderung_prozent_solarthermie"
                                                                    :only-number="true"
                                                                    :number-format="{precision : 2,thousand : '', decimal : ','}"
                                                                    :readonly="!investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].foerderung_calculation_percent"
                                                                    :type="'text'"/>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div v-else class="flex-grow">
                                                    <div class="text-xs mb-2">Förderung gesamt in €</div>
                                                    <base-input v-if="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]" v-model.trim="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].foerderung_custom"
                                                                class="w-full"
                                                                style="margin-bottom: 0; min-width: 150px;"
                                                                :border-color="'border-white'"
                                                                :input-class="'text-center lining-nums tabular-nums'"
                                                                :name="'foerderung_' + activeHouseSelection + '_' + investUndFoard.slug"
                                                                :org-value="getFoerderungByPercent(investUndFoardIndex)"
                                                                :only-number="true"
                                                                :readonly="false"
                                                                :type="'text'"/>
                                                    <div class="flex flex-row -mx-2 items-stretch mt-2 hidden">
                                                      <div class="w-full px-2 flex justify-end flex-col">
                                                        <div class="text-xs mb-2">Wärmeerzeugung + Warmwasserbereitung in %</div>
                                                        <div class="px-3 py-1 border border-gray-200 text-center lining-nums tabular-nums w-full">{{ formatValue(investUndFoard.foerderung_prozent_waermeerzeugung_warmwasserbereitung) }}</div>
                                                      </div>
                                                      <div class="w-full px-2 flex justify-end flex-col" v-if="unformatValue(investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].foerderung_prozent_solarthermie) > 0">
                                                        <div class="text-xs mb-2">Solarthermie in %</div>
                                                        <div class="px-3 py-1 border border-gray-200 text-center lining-nums tabular-nums w-full">{{ formatValue(investUndFoard.foerderung_prozent_solarthermie) }}</div>
                                                      </div>
                                                    </div>

                                                  </div>
                                                </div>
                                                <div class="flex flex-col items-stretch -ml-[1px] flex-shrink">
                                                  <div class="w-full mb-2 w-3 flex justify-end flex-col">
                                                    <div :data-index="investUndFoardIndex" :id="'foerderung_click_b_' + activeHouseSelection + '_' + investUndFoard.slug+ '_ ' + investUndFoardIndex" class="border border-gray-200 bg-body-color px-2 py-1 cursor-pointer" :key="'foerderung_click_b_' + activeHouseSelection + '_' + investUndFoard.slug + '_ ' + investUndFoardIndex" @click="onClickFoerderungTab(investUndFoardIndex, investUndFoard.slug,false)" :class="!isFoerderungTabActive(investUndFoardIndex,investUndFoard.slug) ? 'border-l-transparent pointer-events-none text-primary-default' : 'border-l-gray-200 bg-gray-100'">
                                                      €
                                                    </div>
                                                  </div>
                                                  <div class="w-full w-3 flex justify-end flex-col">
                                                    <div :data-index="investUndFoardIndex" :id="'foerderung_click_a_' + activeHouseSelection + '_' + investUndFoard.slug+ '_ ' + investUndFoardIndex" class="border border-gray-200 bg-body-color px-2 py-1 cursor-pointer" :key="'foerderung_click_a_' + activeHouseSelection + '_' + investUndFoard.slug+ '_ ' + investUndFoardIndex" @click="onClickFoerderungTab(investUndFoardIndex, investUndFoard.slug,true)" :class="isFoerderungTabActive(investUndFoardIndex,investUndFoard.slug) ? 'border-l-transparent pointer-events-none text-primary-default' : 'border-l-gray-200 bg-gray-100'">
                                                      %
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </template>
                                          <template v-else>
                                            -
                                          </template>
                                        </td>

                                        <td class="last-col pr-0 px-2 py-4 align-top text-center" :class="{'border-t': (investUndFoardIndex != 0)}">
                                            <span v-if="investUndFoardIndex === 0" class="font-bold inline-block mt-1">
                                                Referenz
                                            </span>
                                            <div v-else class="flex justify-center mt-2">
                                                <base-checkbox v-if="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex]"
                                                               :name="'selected_' + activeHouseSelection + '_' + investUndFoard.slug"
                                                               :disabled="investUndFoard.disabled || disableForm"
                                                               :class="{'pointer-events-none': disableForm}"
                                                               v-model:checked="investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].selected"
                                                >
                                                </base-checkbox>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                      <span class="text-primary-default">*) Diese Anlagenvarianten erfüllen nach Diskussionsstand 02/2023 die Vorgaben zur Nutzung von 65% erneuerbarer Energien bei neuen Heizungsanlagen. Bei allen anderen Varianten können weitere Maßnahmen erforderlich sein, wie beispielsweise der anteilige Einsatz von Biomethan bei Gasanlagen oder die Nutzung von Solarthermie bzw. Strom aus Photovoltaikanlagen zur Trinkwassererwärmung bei Pelletkesseln.</span>
                    </section>
                    <div class="horizontal-divider"></div>
                    <section v-if="calculationData.weitere_kosten_anlagetechnik">
                        <h2 class="flex items-center">Weitere Kosten Anlagetechnik
                            <div class="inline-block ml-1 flex items-center">
                                <Tooltipp>
                                    <template v-slot:message>
                                        {{ $t('calculator.tt_weitere_kosten_anlagetechnik_' + activeHouseState) }}
                                    </template>
                                </Tooltipp>
                            </div>
                        </h2>
                        <div>
                            <table class="whitespace-no-wrapw-full whitespace-no-wrap w-full relative">

                                <tbody v-if="weitereKostenAnlagetechnikData[activeHouseSelection]">

                                <template v-for="(kostenAnlagetechnik, kostenAnlagetechnikIndex) in calculationData.weitere_kosten_anlagetechnik">
                                    <tr :data-slug="kostenAnlagetechnik.slug" class="table-row">
                                        <td class="pl-0 px-2 py-4 text-left align-top lining-nums tabular-nums" v-bind="mergeCol('weitere_kosten_anlagetechnik',kostenAnlagetechnikIndex)" :class="{'border-t': (kostenAnlagetechnikIndex != 0)}">
                                            {{ kostenAnlagetechnik.name }}
                                        </td>
                                        <td v-if="kostenAnlagetechnik.type" :class="{'border-t': (kostenAnlagetechnikIndex != 0)}">
                                            {{ $t('calculator.type_' + kostenAnlagetechnik.type) }}
                                        </td>
                                        <td v-if="kostenAnlagetechnik.value" class="px-2 py-4 align-top text-center pr-0" :class="{'border-t': (kostenAnlagetechnikIndex != 0)}">
                                            <base-input v-if="weitereKostenAnlagetechnikData[activeHouseSelection][kostenAnlagetechnikIndex]" v-model.trim="weitereKostenAnlagetechnikData[activeHouseSelection][kostenAnlagetechnikIndex].value"
                                                        class="w-full"
                                                        style="margin-bottom: 0; min-width: 150px;"
                                                        :border-color="'border-white'" :input-class="'text-center lining-nums tabular-nums'"
                                                        :name="'weitere_kosten_anlagetechnik_' + activeHouseSelection + '_' + kostenAnlagetechnik.slug"
                                                        :org-value="kostenAnlagetechnik.value"
                                                        :only-number="true"
                                                        :readonly="disableForm"
                                                        :type="'text'"/>
                                        </td>
                                        <td v-else class="px-2 py-4 align-top text-center pr-0" :class="{'border-t': (kostenAnlagetechnikIndex != 0)}">
                                            -
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </section>
                    <div class="flex justify-end items-center mt-10 -mx-2">
                        <!--
                        <router-link class="block flex-grow  px-2" to="/projects">zurück zur Projekübersicht
                        </router-link>
                        -->
                        <div class="px-2">
                            <base-button type="submit" :loading="axiosCall" class="button-min-width" button-class="invert" :disabled="disableForm">
                                {{ edit ? 'Speichern' : 'Speichern' }}
                            </base-button>
                        </div>
                        <div class="px-2">
                            <base-button type="button" @click="onSubmit(1)" :loading="axiosCall" class="button-min-width">
                                zu den Ergebnissen
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

import useVuelidate from '@vuelidate/core'
import {email, required} from '@vuelidate/validators'
import {ref, computed, getCurrentInstance, onMounted, reactive, nextTick} from 'vue'
import {useStore} from "vuex";
import {API} from "@/utils/api";
import {useRouter, useRoute} from "vue-router";
import Slider from '@vueform/slider'
import {isBiggerThanZero} from '@/utils/validators'
import Tooltipp from "../page/Tooltipp";

export default {
    props: {
        edit: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        Tooltipp,
        Slider
    },
    setup(props) {

        const edit = props.edit;
        const store = useStore();
        const generalData = computed(() => store.getters['Calculator/getGeneralData']);
        const configuredData = computed(() => store.getters['Calculator/getConfiguredData']);

        const activeHouseState = computed(() => store.getters['Calculator/getHouseState']);
        const houseStates = store.getters['Calculator/getHouseStates'];
        const activeHouseVariant = computed(() => store.getters['Calculator/getHouseVariant']);
        const houseVariants = store.getters['Calculator/getHouseVariants'];
        const activeHouseAction = computed(() => store.getters['Calculator/getHouseAction']);
        const houseActions = store.getters['Calculator/getHouseActions'];
        const calculationData = computed(() => store.getters['Calculator/getCalculationData']);
        const energieverbrauchPercent = ref(0);

        const energiepreiseData = reactive({})
        const investitionskostenUndFoerderungenData = reactive({})
        const weitereKostenAnlagetechnikData = reactive({})
        const einspeiseverguetungPvStromData = reactive({})


        const allVariantsChecked = computed(() => {

            if (!investitionskostenUndFoerderungenData[activeHouseSelection.value]) return 0;
            const allVaraints = investitionskostenUndFoerderungenData[activeHouseSelection.value].filter(function (el) {
                return !el.disabled
            })

            if (!allVaraints) return false;

            const selectedVariants = allVaraints.filter(function (el) {
                return el.selected == true;
            })
            return allVaraints.length == selectedVariants.length
        })

        const mergeCol = (key, index) => {

            const hasPrev = (index - 1) in calculationData.value[key];
            const hasNext = (index + 1) in calculationData.value[key];


            if (hasPrev && calculationData.value[key][index].name == calculationData.value[key][index - 1].name) return {'class': 'hidden'}
            if (hasNext && calculationData.value[key][index].name == calculationData.value[key][index + 1].name) return {'rowspan': '2'}
        }

        const toggleVariants = async () => {

            var check = true;

            if (allVariantsChecked.value) {
                check = false
            }

            for (const [key, investitionskostenUndFoerderungen] of Object.entries(investitionskostenUndFoerderungenData[activeHouseSelection.value])) {
                if (!investitionskostenUndFoerderungen.disabled) investitionskostenUndFoerderungen.selected = check
            }
        }

        const changeInvestitionskosten = (variant, model) => {

            if (variant.foerderung_factor) {
                let foerderung = variant.foerderung_factor * (accounting.unformat(model.waermeerzeugung, ',') + accounting.unformat(model.warmwasserbereitung, ','));

                model.foerderung = formatValue(foerderung,
                    {
                        symbol: '',
                        format: '%v',
                        precision: 0,
                        decimal: ',',
                        thousand: '.'
                    });
            }

        }

        const activeHouseSelection = computed(() => {

            const activeHouseSelectionValue = `${activeHouseState.value}_${activeHouseVariant.value}_${activeHouseAction.value}`

            return activeHouseSelectionValue
        })

        const energieverbrauchValue = computed(() => {

            if (activeHouseState.value == 'altbau' && calculationData.value.energieverbrauch.value) return (calculationData.value.energieverbrauch.value + (calculationData.value.energieverbrauch.value * (energieverbrauchPercent.value / 100)));

            return 0;
        });

        const energieverbrauchUnit = computed(() => {

            if (activeHouseState.value == 'altbau' && calculationData.value.energieverbrauch.unit) return calculationData.value.energieverbrauch.unit;

            return '';
        });

        const getOffset = (el) => {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
        }

        const clearButtonClass = computed(() => {
            var isEmpty = true;
            for (const [key, value] of Object.entries(generalData.value)) {
                if (value) {
                    isEmpty = false;
                    break;
                }
            }
            return isEmpty ? 'opacity-0 pointer-events-none' : 'opacity-100'
        })

        const defaultHouseActionsData = {}

        for (const [key, value] of Object.entries(houseStates)) {
            defaultHouseActionsData[value] = houseActions[value][0]
        }

        const houseActionsSelected = reactive(defaultHouseActionsData);
        const axiosCall = ref(false);
        const router = useRouter();
        const route = useRoute();
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;
        const accounting = internalInstance.appContext.config.globalProperties.$accounting;
        const openModal = ref(false);
        const hashLink = ref('');
        const appVersion = ref(window.APP_VERSION);
        const showVersionMessage = ref(0);
        const disableForm = ref(false);

        const rules = computed(() => ({
            generalData: {
                name: {}
            }
        }))

        const v$ = useVuelidate(rules, {generalData})

        const setHouseState = (houseState) => {

            store.dispatch('Calculator/setHouseState', houseState);
            store.dispatch('Calculator/setHouseAction', houseActionsSelected[houseState]);

            getCalculationData(true)
        }

        const setHouseVariant = (houseVariant) => {
            store.dispatch('Calculator/setHouseVariant', houseVariant);
            getCalculationData(true)
        }

        const setHouseAction = (houseState, houseActionValue) => {

            houseActionsSelected[houseState] = houseActionValue
            store.dispatch('Calculator/setHouseAction', houseActionValue);
            getCalculationData(true)
        }

        const clearGeneralData = () => {

            if (!confirm("Are you sure?")) return

            store.dispatch('Calculator/clearGeneralData');
        }

        const unformatValues = (dataKeys, selectedData, orgData, format) => {

            for (const [key, selectedDataObject] of Object.entries(selectedData)) {

                for (const dataKey of dataKeys) {

                    let orgValue = orgData[key][dataKey];

                    let orgValueFormat = accounting.formatMoney(orgValue, format)

                    let selectedValue = selectedDataObject[dataKey];

                    // TODO CHECK 0 or false or null value. is value editable? dont set 0 if false

                    if (orgValue !== false) {
                        if (selectedValue == orgValueFormat) {
                            selectedDataObject[dataKey] = orgValue;
                        } else {
                            selectedDataObject[dataKey] = accounting.unformat(selectedValue, ',');
                        }
                    }
                }
            }
        }

        const formatValue = (value, updateSettings) => {
            const defaultSettings = {
                symbol: '',
                format: '%v',
                precision: 2,
                decimal: ',',
                thousand: '.'
            }

            return accounting.formatMoney(value, Object.assign({}, defaultSettings, updateSettings));
        }

        const unformatValue = (value) => {
            return accounting.unformat(value, ',')
        }

        const zinssatzData = ref(formatValue('2.0'));

        const prepareProjectData = (data) => {

            const projectData = JSON.parse(JSON.stringify(data));

            unformatValues(
                ['foerderung', 'foerderung_percent','foerderung_custom', 'waermeerzeugung', 'warmwasserbereitung'],
                projectData.configuredData.investitionskosten_und_foerderungen,
                calculationData.value.investitionskosten_und_foerderungen,
                {
                    symbol: '',
                    format: '%v',
                    thousand: '.',
                    decimal: ',',
                    precision: 0
                }
            )

            unformatValues(
                ['arbeitspreis', 'hausanschlusskosten', 'grundpreis'],
                projectData.configuredData.energiepreise,
                calculationData.value.energiepreise,
                {
                    symbol: '',
                    format: '%v',
                    thousand: '.',
                    decimal: ',',
                    precision: 2
                }
            )


            for (const [key, kostenAnlagetechnikData] of Object.entries(projectData.configuredData.weitere_kosten_anlagetechnik)) {

                kostenAnlagetechnikData.value = accounting.unformat(kostenAnlagetechnikData.value, ',')

            }

            console.log('calculationData.einspeiseverguetung_pv_strom', calculationData.value.einspeiseverguetung_pv_strom, projectData.configuredData.einspeiseverguetung_pv_strom)

            let einspeiseverguetung_pv_strom_org_format = formatValue(calculationData.value.einspeiseverguetung_pv_strom, {
                symbol: '',
                format: '%v',
                precision: 4,
                decimal: ',',
                thousand: '.'
            })

            let einspeiseverguetung_pv_strom_final = (einspeiseverguetung_pv_strom_org_format == projectData.configuredData.einspeiseverguetung_pv_strom) ? calculationData.value.einspeiseverguetung_pv_strom : accounting.unformat(projectData.configuredData.einspeiseverguetung_pv_strom, ',')

            projectData.configuredData.einspeiseverguetung_pv_strom = einspeiseverguetung_pv_strom_final

            projectData.configuredData.zinssatz = accounting.unformat(projectData.configuredData.zinssatz, ',')

            if(!projectData.generalData.name) projectData.generalData.name = 'Objekt'
            return projectData;
        }

        const sortItems = (items, key, reversItems = false) => {
            items.sort((a, b) => {
                return a[key] - b[key]
            })
            if (reversItems) items.reverse();
            return items;
        }

        const onSubmit = (toResult) => {

            v$.value.$touch();

            if (v$.value.$error) {

                scrollTo({
                    top: getOffset(document.getElementById('calculator')).top,
                    left: 0,
                    behavior: 'smooth'
                });

                return;
            }
            ;

            const projectData = prepareProjectData({
                generalData: generalData.value,
                configuredData: {
                    energieverbrauch: {
                        value: energieverbrauchValue.value,
                        unit: energieverbrauchUnit.value,
                        percent: energieverbrauchPercent.value,
                    },
                    energiepreise: energiepreiseData[activeHouseSelection.value],
                    investitionskosten_und_foerderungen: investitionskostenUndFoerderungenData[activeHouseSelection.value],
                    weitere_kosten_anlagetechnik: weitereKostenAnlagetechnikData[activeHouseSelection.value],
                    einspeiseverguetung_pv_strom: calculationData.value.einspeiseverguetung_pv_strom ? einspeiseverguetungPvStromData[activeHouseVariant.value] : 0,
                    zinssatz: zinssatzData.value

                },
                calculationData: calculationData.value,
                houseState: activeHouseState.value,
                houseVariant: activeHouseVariant.value,
                houseAction: activeHouseAction.value
            })

            if (route.params.id && edit) {
                projectData.id = route.params.id
            }

            axiosCall.value = true;

            projectData.toResult = toResult;

            API.post(edit ? 'updateProject' : 'createProject', projectData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(async (resp) => {
                axiosCall.value = false;
                /*
                emitter.emit("flash-message", {
                    text: resp.data.message,
                    type: 'success'
                })
                */

                //hashLink.value = resp.data.link + encodeURIComponent(resp.data.hash);
                //openModal.value = !openModal.value;

                await store.dispatch('Calculator/setGeneralData', resp.data.project.generalData);
                await store.dispatch('Calculator/setConfiguredData', resp.data.project.configuredData);

                if (toResult) return router.push('/form/result/' + resp.data.id);
                if (!edit) router.push('/form/edit/' + resp.data.id);

            }).catch(err => {
                axiosCall.value = false
                console.log(err);
                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })
        }



        const getIconName = (slug) => {

            let iconName;

            switch (slug) {
                case 'rate_IST_01':
                case 'erdgas':
                case 'erdgas_biomethan_10':
                case 'erdgas_25000_bis_50000_kwh':
                case 'erdgas_bis_25000_kwh':
                case 'erdgas_ueber_50000_kwh':
                case 'erdgas_biomethan_15':
                case 'erdgas_biomethan_55':
                case 'erdgas_biomethan_65':
                    iconName = 'erdgas';
                    break;
                case 'rate_IST_02':
                case 'heizoel':
                case 'heizoel_4000l':
                case 'heizoel_3000l':
                case 'heizoel_1600l':
                case 'heizoel_biooel_10':
                    iconName = 'heizoel';
                    break;
                case 'strom_waermepumpentarif':
                case 'strom_normaltarif':
                    iconName = 'strom';
                    break;
                case 'pellets':
                case 'pellet_4t':
                case 'pellet_8t':
                case 'pellet_10t':
                case 'pellet_sackware':
                    iconName = 'pellets';
                    break;
                case 'nah_fern_waerme':
                    iconName = 'nah_fern_waerme'
                    break;
                default:
                    iconName = '';
            }

            return iconName;
        }

        const getCalculationData = (loader) => {

            if (loader) axiosCall.value = true;

            let versionNumber = appVersion.value ? appVersion.value : window.APP_VERSION;

            API.get(`getCalculationData/${activeHouseState.value}/${activeHouseVariant.value}/${activeHouseAction.value}/${versionNumber}`).then((resp) => {
                if (loader) axiosCall.value = false;

                const calculationData = resp.data;

                console.log('calculationData', calculationData)

                if (!energiepreiseData[`${activeHouseState.value}_${activeHouseVariant.value}_${activeHouseAction.value}`]) {

                    energiepreiseData[`${activeHouseState.value}_${activeHouseVariant.value}_${activeHouseAction.value}`] = JSON.parse(JSON.stringify(calculationData.energiepreise));
                }

                if (!investitionskostenUndFoerderungenData[`${activeHouseState.value}_${activeHouseVariant.value}_${activeHouseAction.value}`]) {

                    investitionskostenUndFoerderungenData[`${activeHouseState.value}_${activeHouseVariant.value}_${activeHouseAction.value}`] = JSON.parse(JSON.stringify(calculationData.investitionskosten_und_foerderungen));
                }

                if (!weitereKostenAnlagetechnikData[`${activeHouseState.value}_${activeHouseVariant.value}_${activeHouseAction.value}`]) {

                    weitereKostenAnlagetechnikData[`${activeHouseState.value}_${activeHouseVariant.value}_${activeHouseAction.value}`] = JSON.parse(JSON.stringify(calculationData.weitere_kosten_anlagetechnik));
                }

                if (!einspeiseverguetungPvStromData[`${activeHouseVariant.value}`] || calculationData.einspeiseverguetung_pv_strom === 0) {

                    einspeiseverguetungPvStromData[`${activeHouseVariant.value}`] = JSON.parse(JSON.stringify(calculationData.einspeiseverguetung_pv_strom));
                }

                if (!zinssatzData.value) {
                    zinssatzData.value = calculationData.zinssatz
                }

                store.dispatch('Calculator/setCalculationData', calculationData);


            }).catch(err => {
                if (loader) axiosCall.value = false;
                console.error(err)
            })
        }

        onMounted(() => {

            (async () => {

                axiosCall.value = true;
                await nextTick();
                await API.get('user').then((response) => {
                    store.dispatch('Customer/setUser', response.data)
                }).catch((error) => {
                    store.dispatch('Customer/logout')
                })

                if (edit) {
                    await API.post('getProject', {id: route.params.id}).then((resp) => {
                        axiosCall.value = false;
                        const projectData = resp.data.project;

                        const projectAppVersion = resp.data.version;
                        appVersion.value = projectAppVersion;

                        showVersionMessage.value =  projectAppVersion.localeCompare(window.APP_VERSION, undefined, { numeric: true, sensitivity: 'base' });

                        disableForm.value = !(showVersionMessage.value === 0);

                        console.log('appVersion', appVersion)
                        if (projectData['generalData']) store.dispatch('Calculator/setGeneralData', projectData['generalData']);

                        //if(projectData['calculationData']) store.dispatch('Calculator/setCalculationData', projectData['calculationData']);
                        if (projectData.houseState) store.dispatch('Calculator/setHouseState', projectData.houseState);
                        if (projectData.houseAction) store.dispatch('Calculator/setHouseAction', projectData.houseAction);
                        if (projectData.houseVariant) store.dispatch('Calculator/setHouseVariant', projectData.houseVariant);

                        if (projectData['configuredData']) {
                            store.dispatch('Calculator/setConfiguredData', projectData['configuredData']);
                            if (projectData['configuredData'].energieverbrauch) {

                                const energieverbrauchData = projectData['configuredData'].energieverbrauch;
                                if (energieverbrauchData.value) energieverbrauchValue.value = energieverbrauchData.value
                                if (energieverbrauchData.unit) energieverbrauchUnit.value = energieverbrauchData.unit
                                if (energieverbrauchData.percent) energieverbrauchPercent.value = energieverbrauchData.percent
                            }

                            if (projectData['configuredData'].energiepreise) energiepreiseData[activeHouseSelection.value] = projectData['configuredData'].energiepreise;
                            if (projectData['configuredData'].investitionskosten_und_foerderungen) investitionskostenUndFoerderungenData[activeHouseSelection.value] = projectData['configuredData'].investitionskosten_und_foerderungen;
                            if (projectData['configuredData'].weitere_kosten_anlagetechnik) weitereKostenAnlagetechnikData[activeHouseSelection.value] = projectData['configuredData'].weitere_kosten_anlagetechnik;
                            if (projectData['configuredData'].einspeiseverguetung_pv_strom) einspeiseverguetungPvStromData[activeHouseVariant.value] = projectData['configuredData'].einspeiseverguetung_pv_strom;
                            if (projectData['configuredData'].einspeiseverguetung_pv_strom === 0) einspeiseverguetungPvStromData[activeHouseVariant.value] = '0.0000';
                            if (projectData['configuredData'].zinssatz) zinssatzData.value = projectData['configuredData'].zinssatz;
                            if (projectData['configuredData'].zinssatz === 0) zinssatzData.value = '0.00';

                        }
                    }).catch(err => {
                        axiosCall.value = false
                        console.error(err)
                        console.log(err.response)
                        emitter.emit("flash-message", {
                            text: err.response.data.message,
                            type: 'error'
                        })
                        router.push('/projects');
                    })

                } else {
                    store.dispatch('Calculator/clearGeneralData');
                    store.dispatch('Calculator/resetHouseData');
                }

                await getCalculationData();

                axiosCall.value = false;
            })()
        })

        const isNotEditable = (slug) => {

            if (['EFH_IST_01', 'EFH_IST_02', '6-FH_IST_01', '6-FH_IST_02'].includes(slug)) return true;

            return false;
        }

        const onClickFoerderungTab = (investUndFoardIndex, slug, value) => {
          investitionskostenUndFoerderungenData[activeHouseSelection.value][investUndFoardIndex].foerderung_calculation_percent = value
        }

        const isFoerderungTabActive = (investUndFoardIndex, slug) => {
          return investitionskostenUndFoerderungenData[activeHouseSelection.value][investUndFoardIndex]?.foerderung_calculation_percent
        }

        const getFoerderungByPercent = (investUndFoardIndex, custom) => {


          let foerderungData = investitionskostenUndFoerderungenData[activeHouseSelection.value][investUndFoardIndex];
          let foerderung = 0;
          let foerderungProzentWaermeerzeugungWarmwasserbereitung = unformatValue(foerderungData['foerderung_prozent_waermeerzeugung_warmwasserbereitung' + (custom ? '_custom':'')]) / 100;
          let foerderungProzentSolarthermie = unformatValue(foerderungData['foerderung_prozent_solarthermie' + (custom ? '_custom':'')]) / 100;
          let waermeerzeugung =  unformatValue(foerderungData.waermeerzeugung);
          let warmwasserbereitung = unformatValue(foerderungData.warmwasserbereitung);
          let nichtFoerderfaehigeKostenHybridsystem = foerderungData.nicht_foerderfaehige_kosten_hybridsystem || 0
          let kostenanteilPhotovoltaikanlage = foerderungData.kostenanteil_photovoltaikanlage || 0;
          let kostenanteilSolareHeizungsunterstuetzung = foerderungData.kostenanteil_solare_heizungsunterstuetzung || 0
          let foerderungHausanschlussWaermenetz = 0;

          if (foerderungData.foerderung_hausanschluss_waermenetz) {
            foerderungHausanschlussWaermenetz = foerderungProzentWaermeerzeugungWarmwasserbereitung * (unformatValue(energiepreiseData[activeHouseSelection.value].find(ep => ep.slug == foerderungData?.hausanschlusskosten?.energiepreise)?.hausanschlusskosten) || 0)
          }

          let foerderungHeizungsoptimierungUndHeizflaechen = foerderungProzentWaermeerzeugungWarmwasserbereitung * unformatValue(weitereKostenAnlagetechnikData[activeHouseSelection.value].find(wkad => wkad.slug == foerderungData.weitere_kosten_anlagetechnik)?.value || 0);
          if (foerderungProzentWaermeerzeugungWarmwasserbereitung > 0 && foerderungProzentSolarthermie > 0) {
            foerderung = waermeerzeugung * (1 - nichtFoerderfaehigeKostenHybridsystem) * foerderungProzentWaermeerzeugungWarmwasserbereitung + warmwasserbereitung * foerderungProzentSolarthermie;
          } else {
            foerderung = foerderungProzentWaermeerzeugungWarmwasserbereitung * (waermeerzeugung * (1 - kostenanteilPhotovoltaikanlage) * (1 - nichtFoerderfaehigeKostenHybridsystem) + warmwasserbereitung) + (kostenanteilSolareHeizungsunterstuetzung * waermeerzeugung * (1 - kostenanteilPhotovoltaikanlage) * (1 - nichtFoerderfaehigeKostenHybridsystem) + warmwasserbereitung) * foerderungProzentSolarthermie;
          }
          foerderung = foerderung + foerderungHausanschlussWaermenetz + foerderungHeizungsoptimierungUndHeizflaechen;
          if (custom) investitionskostenUndFoerderungenData[activeHouseSelection.value][investUndFoardIndex].foerderung_percent = foerderung
          return formatValue(foerderung, {precision: 0});
          //formatValue(investitionskostenUndFoerderungenData[activeHouseSelection][investUndFoardIndex].foerderung,{precision: 0} )
        }

        return {
            generalData,
            configuredData,
            onSubmit,
            v$,
            axiosCall,
            openModal,
            hashLink,
            activeHouseState,
            houseStates,
            setHouseState,
            activeHouseVariant,
            houseVariants,
            setHouseVariant,
            activeHouseAction,
            houseActions,
            setHouseAction,
            houseActionsSelected,
            activeHouseSelection,
            calculationData,
            energieverbrauchPercent,
            energieverbrauchUnit,
            energieverbrauchValue,
            clearGeneralData,
            clearButtonClass,
            energiepreiseData,
            investitionskostenUndFoerderungenData,
            weitereKostenAnlagetechnikData,
            einspeiseverguetungPvStromData,
            zinssatzData,
            toggleVariants,
            allVariantsChecked,
            mergeCol,
            sortItems,
            getIconName,
            formatValue,
            edit,
            isNotEditable,
            unformatValue,
            changeInvestitionskosten,
            appVersion,
            showVersionMessage,
            disableForm,
          onClickFoerderungTab,
          isFoerderungTabActive,
          getFoerderungByPercent
        }
    }
}
</script>

<style lang="scss" scoped>

table#investitionskosten {
    .first-col {
        width: 330px;
    }

    .last-col {
        width: 50px;
    }

    .input-col {
        width: 330px;
    }

}
</style>
